// extracted by mini-css-extract-plugin
export var aboveInput = "_jj-0";
export var actionButton = "_jj-5";
export var actionButtonContainer = "_jj-1";
export var actionIcon = "_jj-6";
export var aiInfoContainer = "_jj-2";
export var attachmentWrapper = "_jj-7";
export var bold = "_jj-3";
export var checkIcon = "_jj-8";
export var clickingRecipientBar = "_jj-11";
export var commentThreadSwitch = "_jj-a";
export var draftImage = "_jj-b";
export var draftImageContainer = "_jj-c";
export var draftImages = "_jj-e";
export var editButton = "_jj-g";
export var editor = "_jj-f";
export var editorContainer = "_jj-y";
export var editorErrorTooltipWrapper = "_jj-9";
export var headerDivider = "_jj-h";
export var icon = "_jj-i";
export var info = "_jj-j";
export var internal = "_jj-n";
export var internalDivider = "_jj-k";
export var internalMessage = "_jj-l";
export var messageInputCard = "_jj-m";
export var messageInputForm = "_jj-o";
export var messageInputFormInternal = "_jj-p";
export var options = "_jj-q";
export var publicMessageCustomer = "_jj-s";
export var publicMessageMerchant = "_jj-r";
export var removeImageButton = "_jj-d";
export var replyButtons = "_jj-t";
export var showSignatureButton = "_jj-u";
export var spinner = "_jj-v";
export var verticalButtonDivider = "_jj-4";
export var visibilitySelector = "_jj-w";
export var warning = "_jj-x";
export var wrappingText = "_jj-z";
export var writingInternalNoteTopBorder = "_jj-10";